// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"423":"css/fonts_icons","6170":"css/app"}[chunkId] + ".css";
};